import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	content: {
		flexGrow: 1,
		display: "flex",
		flexDirection: "column",
		position: "relative",
		minHeight: "20vh",
		marginTop: "1.6rem",
	},
	contentMd: {
		flexGrow: 0,
		display: "flex",
		flexDirection: "column",
		position: "relative",
		minHeight: "20vh",
	},

	mainContainer: {
		"&&": {
			margin: "0 auto",
			width: "100%",
			marginTop: 0,
			flexGrow: 1,
			display: "flex",
			flexDirection: "column",
			maxWidth: "1440px",
		},
	},

	panelDark: {
		boxShadow: "none",
		marginBottom: 0,
		position: "relative",
		borderRadius: "8px",
		padding: "40px 24px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "16px",
		flexGrow: 1,
		background: "#242439",
		color: "#fff",
	},
	contentFooter: {
		flexGrow: 1,
	},
	iconFooter: {},
	smallHeading: {
		"&&": {
			fontSize: "12px",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "16px",
			letterSpacing: "0.2px",
			margin: 0,
			marginBottom: "8px",
		},
	},
	phone: {
		"&&": {
			fontSize: "32px",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "40px",
		},
	},
	subTitle: {
		"&&": {
			fontSize: "16px",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "24px",
			margin: 0,
		},
	},
	description: {
		"&&": {
			fontSize: "12px",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "16px",
			letterSpacing: "0.2px",
			paddingBottom: "16px",
			marginBottom: 0,
		},
	},
	lastItem: {
		"&&": {
			paddingBottom: 0,
		},
	},
}));
